import { useMutation } from '@tanstack/react-query';
import container from '@/_shared/services/service-container';
import { EmailService } from '@/_shared/services';
import { ContactFormRequest } from '@/_shared/models/research/contact-form.model';
import { EmailRequest } from '@/_shared/_api/models/email.model';

const emailService = container.get<EmailService>('EmailService');

// 1. Send Verification
export const useSendVerification = () =>
  useMutation({
    mutationFn: async (payload: EmailRequest) => {
      const res = await emailService.sendVerification(payload);
      return res.data;
    },
  });

// 2. Resend Verification
export const useResendVerification = () =>
  useMutation({
    mutationFn: async (token: string) => {
      const res = await emailService.resendVerification(token);
      return res.data;
    },
  });

// 3. Update Account Verification (using fetch)
export const useUpdateAccountVerification = () =>
  useMutation({
    mutationFn: async (id: number) => {
      const resp = await emailService.updateAccountVerification(id);
      return resp.data;
    },
  });

// 4. Send Reset Password
export const useSendResetPassword = () =>
  useMutation({
    mutationFn: async (payload: EmailRequest) => {
      const resp = await emailService.sendResetPassword(payload);
      return resp.data;
    },
  });

export function useSendResearchContactForm(userId: number) {
  return useMutation({
    mutationFn: async (values: ContactFormRequest) => {
      const response = await emailService.sendResearchContactForm(
        values,
        userId
      );
      return response.data;
    },
  });
}

export function useSendContactForm(userId: number) {
  return useMutation({
    mutationFn: async (values: ContactFormRequest) => {
      const response = await emailService.sendContactUsForm(values, userId);
      return response.data;
    },
  });
}
